import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Button, Input, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { formatWtfNl, parseWtfNl } from '../utils/formatWtf';
import ReactTableGeneric from 'Components/ReactTableGeneric';

const AfasLangeWtfEditModal = ({ isOpen, days = [], onClose, onSave }) => {
    const [values, setValues] = useState({});

    useEffect(() => {
        if (!isOpen) {
            return;
        }

        const next = {};
        days.forEach((day) => {
            const key = day.dayKey || day.id;
            next[key] = formatWtfNl(day.wtf);
        });
        setValues(next);
    }, [isOpen, days]);

    const handleValueChange = useCallback((key, next) => {
        setValues((prev) => ({ ...prev, [key]: next }));
    }, []);

    // Keep columns stable (do NOT depend on `values`), otherwise the inputs
    // remount on every keystroke and lose focus.
    const columns = useMemo(
        () => [
            {
                accessorKey: 'dag',
                header: 'Dag',
                cell: ({ row }) => (
                    <span className=" fw-semibold">{row.original.dag}</span>
                ),
            },
            {
                accessorKey: 'value',
                header: 'WTF',
                size: 50,
                cell: ({ row }) => (
                    <Input
                        id={`afas-lange-wtf-${row.original.key}`}
                        type="text"
                        className="form-control form-control-sm afas-input-modal"
                        value={row.original.value}
                        onChange={(event) =>
                            handleValueChange(row.original.key, event.target.value)
                        }
                    />
                ),
            },
        ],
        [handleValueChange],
    );

    const tableData = useMemo(
        () =>
            days.map((day) => {
                const key = day.dayKey || day.id;
                return { ...day, key, value: values[key] ?? '' };
            }),
        [days, values],
    );

    const handleSave = () => {
        const nextDays = days.map((day) => {
            const key = day.dayKey || day.id;
            return {
                ...day,
                wtf: parseWtfNl(values[key]),
            };
        });
        onSave?.(nextDays);
    };

    return (
        <Modal isOpen={isOpen} toggle={onClose} className="modal-dialog__over link-form afas-modal-style opmerking-modal-styling info-afas-modal-width">
            <ModalHeader toggle={onClose}>
                Wijzig WTF dag
            </ModalHeader>
            <ModalBody>
                <div className="table-responsive rounded">
                    <ReactTableGeneric
                        data={tableData}
                        columns={columns}
                        filters={{
                            search: false,
                            pagination: false,
                            sorting: false,
                        }}
                        tableClassName="mb-0 table table-sm table-hover table-borderless align-middle"
                        count={tableData.length}
                    />
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={onClose} outline
                            className="btn-outline-primary-blue btn-color-style footer--coordinator-planboard__btn">
                    Annuleren
                </Button>
                <Button color="primary" onClick={handleSave} outline
                            className="btn-outline-primary-blue btn-color-style footer--coordinator-planboard__btn ms-1">
                    Toepassen
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default AfasLangeWtfEditModal;